import * as config from './config.js' ;
import { AJAX } from './helpers.js';


export const state = { // All The Data Of The App
    recipe:{},
    search: {
        query:'',
        results: [],
        page: 1,
        resultsPerPage: 10,
    },
    bookmarks: [],
    
}

const createRecipeData = function(data)
{
    const {recipe} = data.data;
        return{
            id: recipe.id,
            title: recipe.title,
            publisher: recipe.publisher,
            sourceUrl: recipe.sourceUrl,
            image: recipe.image_url,
            servings: recipe.servings,
            cookingTime:recipe.cooking_time,
            ingredients: recipe.ingredients,
            ...(recipe.key && {key:recipe.key})
        };
}

export const loadRecipe = async function(hash)
{
    try{
        const data = await AJAX(`${config.API_URL}${hash}?key=${config.KEY}`)
        state.recipe = createRecipeData(data);
        
        if(state.bookmarks.some(b => b.id === state.recipe.id)){
            state.recipe.bookmarked = true;
        }
        else{
            state.recipe.bookmarked = false;
        }
    }
    catch(err){
        throw err;
    }
}


export const loadSearchResult = async function(query)
{
    try{
        state.search.query = query;
        const res = await AJAX(`${config.API_URL}?search=${query}&key=${config.KEY}`);



        state.search.results = res.data.recipes.map(rec=>{
            return {
                id: rec.id,
                title: rec.title,
                publisher: rec.publisher,
                sourceUrl: rec.sourceUrl,
                image: rec.image_url,
                ...(rec.key && {key : rec.key}),
            }
        });
        return state.search.results;
    }
    catch(err){
        throw err;
    }
}

export const getSearchResultsPage = function(page = state.search.page)
{
    state.search.page = page;

    const start = (page-1) * state.search.resultsPerPage;
    const end = page * state.search.resultsPerPage;


    return state.search.results.slice(start , end)
}

export const updateServings = function(newServings)
{
    state.recipe.ingredients.forEach(el => {
        el.quantity = (el.quantity *  newServings) / state.recipe.servings;
    });
    state.recipe.servings = Number(newServings);
}

const presistBookmarks = function()
{
    localStorage.setItem('bookmarks' , JSON.stringify(state.bookmarks));
}

export const addBookmark = function(recipe)
{
    state.bookmarks.push(recipe);

    if(recipe.id === state.recipe.id) state.recipe.bookmarked = true;
    presistBookmarks();
    
} 

export const deleteBookmark = function(id)
{
    const index = state.bookmarks.findIndex(el=> el.id === id);
    state.bookmarks.splice(index , 1);
    
    if(id === state.recipe.id) state.recipe.bookmarked = false;
    presistBookmarks();
}

const init = function()
{
    const storage = localStorage.getItem('bookmarks');
    if(storage) state.bookmarks = JSON.parse(storage);
}
init();

const clearBookmarks = function()
{
  localStorage.removeItem('bookmarks');
}

export const uploadRecipeData = async function(newRecipe)
{
    try{
        const ingredients = Object.entries(newRecipe)
        .filter(entry => entry[0].startsWith('ingredient') && entry[1] !== '')
        .map(ing => {
            const ingArr = ing[1].replaceAll(' ', '').split(',');
            if(ingArr.length !== 3) throw new Error("Wrong Ingredient Format");
    
            const [quantity , unit , description] = ingArr;
    
            return {quantity: quantity ? +quantity : null , unit , description};
        });
        console.log(ingredients);

        const recipe = {
            title: newRecipe.title,
            source_url: newRecipe.sourceUrl,
            image_url: newRecipe.image,
            publisher: newRecipe.publisher,
            cooking_time: +newRecipe.cookingTime,
            servings: +newRecipe.servings,
            ingredients,
        }
        const data = await AJAX(`${config.API_URL}?key=${config.KEY}`, recipe);
        state.recipe = createRecipeData(data);
        addBookmark(state.recipe);
    state
    }catch(err){
        throw err;
    }
    
}
